module.exports = __webpack_public_path__ + "./images/donut-placeholder.b0a6e9.jpg";